export default __webpack_public_path__ + "static/media/branding-logo.c56a3733.svg";